/**
 * Application configuration
 */
export const CONFIG = {
  // Sigma 5 is Subcentres, 114 is Cities
  sigmaValues: Array.from({ length: 500 }, (_, i) => i + 1),
  defaultSigma: 5,
  cellSizes: [100],
  defaultCellSize: 100,
  geoserverUrl: 'https://sanghoon.ca/geoserver/wms',
  basemaps: {
    osm: {
      url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attributions: ['© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors']
    },
    carto: {
      url: `https://{1-4}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=${encodeURIComponent(import.meta.env.VITE_CARTO_BASEMAP_KEY)}`,
      attributions: ['© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, © <a href="https://carto.com/attributions">CARTO</a>']
    },
    esriImagery: {
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      attributions: ['Tiles © <a href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer">ESRI</a>']
    },
    esriStreetMap: {
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
      attributions: ['Tiles © <a href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer">ESRI</a>']
    },
    esriTopo: {
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
      attributions: ['Tiles © <a href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer">ESRI</a>']
    },
    esriRelief: {
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}',
      attributions: ['Tiles © <a href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer">ESRI</a>']
    }
  },
  referenceLayers: {
    none: {
      id: 'no-reference',
      label: 'None',
      key: 'none'
    },
    cz20: {
      id: 'cz20-toggle',
      label: 'CZ 2020 (Fowley)',
      key: 'cz20',
      geoserverLayer: 'watersheds:cz20'
    },
    cbsa: {
      id: 'cbsa-toggle',
      label: 'CBSA 2010 (US OMB)',
      key: 'cbsa',
      geoserverLayer: 'watersheds:cbsa'
    },
    fua: {
      id: 'fua-toggle',
      label: 'FUA (OECD)',
      key: 'fua',
      geoserverLayer: 'watersheds:fua'
    },
    efua: {
      id: 'efua-toggle',
      label: 'eFUA 2019 (GHS)',
      key: 'efua',
      geoserverLayer: 'watersheds:efua2019'
    },
    pl_all_uscbsas: {
      id: 'pl-all-uscbsas-toggle',
      label: 'Prime Locations (AAB)',
      key: 'pl_all_uscbsas',
      geoserverLayer: 'watersheds:pl_all_uscbsas'
    }
  },
  animation: {
    duration: 1000, // Pause duration at end of cycle
    sigmasPerSecond: 1 // Base speed for animation
  },
  defaultPop: 0, // Default minimum population
  maxZoom: 18
};